const taskTemplates = require('../../task-templates');

const tasksData = [		
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 1,
    taskNumber: 1,
    title: 'Opgave 1',
    taskId: 'example-area-mc-fruits',
    text: 'Hvilke af disse er frugter?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Banan', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Æble', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Appelsin', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Gulerod', 
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 1,
    taskNumber: 2,
    title: 'Opgave 2',
    taskId: 'example-area-mc-berries',
    text: 'Hvilke af disse er bær?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Blåbær', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Hindbær',
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Ribs', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Jordbær', 
      })
    ],
  }), 
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 2,
    taskNumber: 1,
    title: 'Opgave 1',
    taskId: 'example-area-mc-colors',
    text: 'Hvilke af disse er farver?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Blå', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Grøn',
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Rød', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Appelsin', 
      })
    ],
  }), 
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 2,
    taskNumber: 2,
    title: 'Opgave 2',
    taskId: 'example-area-mc-shapes',
    text: 'Hvilke af disse er former?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Cirkel', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Firkant',
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Trekant', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Banan', 
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 3,
    taskNumber: 1,
    title: 'Opgave 1',
    taskId: 'example-area-mc-animals',
    text: 'Hvilke af disse er dyr?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Hund', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Kat',
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Papegøje', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Banan', 
      })
    ],
  }),
  Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
    caseId: 3,
    taskNumber: 2,
    title: 'Opgave 2',
    taskId: 'example-area-mc-vehicles',
    text: 'Hvilke af disse er køretøjer?',
    options: [
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 1,
        text: 'Bil', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 2,
        text: 'Bus',
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 3,
        text: 'Tog', 
        isCorrect: true
      }),
      Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
        id: 4,
        text: 'Banan', 
      })
    ],
  })  
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
  /* Assign unique id used for navigation */
  task.id = 'example-area-' + (index + 1 < 10 ? '0' : '') + (index + 1);

  /* Check taskId is set when required and unique */
  if (task.taskId) {
    if (taskIdsArr.indexOf(task.taskId) >= 0) {
      console.error('Task id not unique: ', task.taskId);
    } else {
      taskIdsArr.push(task.taskId);
    }
  } else {
    console.error('Missing task id for task: ', task);
  }
});

export {
  tasksData
};